module.exports = __webpack_public_path__ + "static/media/million-round-img.f600858d.png";